/**
 * Das `documents`-Feld einer Entität lesen.
 *
 * Ein Eintrag ist **entweder** die blanke Id einer Datei **oder** ein Satz mit Herkunft:
 * `{ managedFileId, role, subtype, herkunft }`. Beide Formen stehen im Bestand nebeneinander — die
 * blanke Id kommt vom Hochladen am Objekt, der Satz vom Merge, der festhält, aus welchem Dokument
 * ein Objekt hervorgegangen ist (`herkunft: 'quelle'`).
 *
 * **Ohne diese Normalisierung liest sich ein Satz als `"[object Object]"`.** Die Abfrage findet
 * dann nichts, die Ansicht zeigt „keine Unterlagen", und niemand sieht einen Fehler — dieselbe
 * stumme Fehlerart, die schon einmal einen halben Tag gekostet hat.
 */

/** Die Id eines Eintrags, gleich welcher Form. Leerer String, wenn nichts Brauchbares drinsteht. */
export const documentIdOf = (entry: any): string => {
  if (!entry) return "";
  if (typeof entry === "string") return entry;
  if (typeof entry !== "object") return String(entry);
  if (entry.managedFileId) return documentIdOf(entry.managedFileId);
  if (entry.$oid) return String(entry.$oid);
  // `_id !== entry` fängt die ObjectId ab, deren `_id`-Getter auf sie selbst zeigt.
  if (entry._id && entry._id !== entry) return documentIdOf(entry._id);
  return String(entry);
};

/** Die Ids eines ganzen `documents`-Feldes, ohne leere. */
export const documentIdsOf = (documents: any): string[] =>
  (Array.isArray(documents) ? documents : []).map(documentIdOf).filter(Boolean);
